<template>
  <div ref="fontsRef" v-outside-click="hide" class="kk-design__select-font">
    <div
      v-for="(fontname, index) in AllFonts"
      :key="index"
      :class="{ 'kk-design__select-font_active': activeIndex === index }"
    >
      <font-item :fontname="fontname" @select-font="selectFont" />
    </div>
  </div>
</template>

<script>
import { AllFonts, HotkeyScopes } from "../../../../utils/constants";
import FontItem from "./FontItem.vue";
import hotkeys from "hotkeys-js";
export default {
  components: {
    FontItem,
  },
  emits: ["select-font", "hide"],
  data() {
    return {
      AllFonts,
      activeIndex: -1,
    };
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.SelectFont);
    hotkeys("up, down, escape, enter", HotkeyScopes.SelectFont, (event, handler) => {
      event.preventDefault();
      switch (handler.key) {
        case "up":
          this.moveUp();
          break;
        case "down":
          this.moveDown();
          break;
        case "escape":
          this.hide();
          break;
        case "enter":
          this.selectFont(AllFonts[this.activeIndex], true);
          break;
      }
    });
  },
  beforeUnmount() {
    hotkeys.unbind("up, down, escape, enter", HotkeyScopes.SelectFont);
    this.$store.dispatch("setScope", HotkeyScopes.EditToolBox);
  },
  methods: {
    selectFont(fontname, showTooltip) {
      this.$emit("select-font", fontname, showTooltip);
    },
    hide() {
      this.$emit("hide");
    },
    moveDown() {
      this.activeIndex = (this.activeIndex + 1) % AllFonts.length;
    },
    moveUp() {
      this.activeIndex = this.activeIndex <= 0 ? AllFonts.length - 1 : (this.activeIndex - 1) % AllFonts.length;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";

.kk-design {
  &__select-font {
    width: 10rem;
    max-height: 20rem;
    transform: translate(0%, 60%);
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0.3rem;
    position: absolute;
    border-radius: 8px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border: 0.5px solid lightgray;
    background-color: @kk-color-background;
    &_active {
      background-color: @kk-color-light-blue;
    }
  }
}
</style>
